var styles = {
  "popup": "ktl-popup-module_popup_kH56U",
  "overlay": "ktl-popup-module_overlay_lHomr",
  "close": "ktl-popup-module_close_Cvlga"
};
export { styles as default };
